<template>
  <div class="text-center text-base leading-normal">
    <p v-if="!isPauseTab" class="whitespace-pre-line md:whitespace-normal">
      {{ $t('ec-line014.lumpsum.shopInfo.info') }}
    </p>
    <p v-if="isPauseTab" class="whitespace-pre-line md:whitespace-normal">
      {{ $t('ec-line014.lumpsum.shopInfo.reopenInfo') }}
    </p>
    <p class="text-xl font-bold mt-2">{{ Utils.helper.formatPhoneNumber(shop.phone_number) }}</p>
    <p>{{ shop.business_hour }}</p>
  </div>
</template>

<script>
export default {
  name: 'InquiryInformation',
  props: {
    isPauseTab: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    shop() {
      return this.$store.getters['auth/shop']
    },
  },
}
</script>

<style scoped lang="scss"></style>
